// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1qs13","header":"ReportDetails_header__3lTM_","title":"ReportDetails_title__107Mx","left":"ReportDetails_left__2q09w"};